'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialApple = function IoSocialApple(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.1 12c1.9 0 4.1 1.1 5.5 3.1-4.9 2.8-4.1 10 0.9 11.9-0.7 1.6-1 2.2-1.9 3.6-1.2 2-2.9 4.4-5.1 4.4h0c-1.9 0-2.5-1.2-5-1.2-2.5 0-3.1 1.2-5 1.2h0c-2.2 0-3.8-2.2-5-4.1-3.5-5.4-3.8-11.8-1.7-15.1 1.5-2.4 3.9-3.8 6.1-3.8 2.3 0 3.7 1.3 5.6 1.3 1.8 0 2.9-1.3 5.6-1.3z m-0.6-7c0.2 1.8-0.5 3.6-1.4 4.8-1.1 1.4-2.8 2.4-4.4 2.4h-0.1c-0.3-1.7 0.5-3.4 1.4-4.7 1.1-1.3 2.9-2.4 4.5-2.5z' })
        )
    );
};

exports.default = IoSocialApple;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-apple.js
// module id = 2447
// module chunks = 0